import { Redirect, RouteComponentProps, Router } from '@reach/router';
import { useUsingAxisSettings } from '../../hooks/useUsingAxisSettings';
import { axisPaths } from './AxisConstants';
import { AxisWelcomePage } from './AxisWelcomePage';
import {
  OtherInquiryPage,
  PromotionalPage,
  PaymentsPage,
  ClaimsInquiryPage,
  CurrentClientPage,
  DemoBasicInformationPage,
} from './BasicInformationPages';
import { AxisBasicInformationThankYou } from './AxisBasicInformationThankYou';
import { NewClientPage } from './pages/NewClientPage';
import { useSettings } from '../../hooks';
import { HelpButton } from './components/HelpButton';
import Box from '@mui/material/Box';
import styled from '@mui/material/styles/styled';
import { AxisFooter } from '../../WhiteLabelSettings/Axis/Footer';
import { useWhiteLabelGoogleTag } from '../../hooks/useWhiteLabelGoogleTag/useWhiteLabelGoogleTag';
import { useAxisPageMetadata } from './useAxisPageMetadata';

interface AxisProps extends RouteComponentProps {}

export const Axis = (_props: AxisProps) => {
  const { ready, settings } = useSettings();
  const usingAxis = useUsingAxisSettings();
  const analytics = useWhiteLabelGoogleTag(
    ready && usingAxis ? settings.googleAnalyticsToken : undefined,
  );
  useAxisPageMetadata({
    active: ready && usingAxis,
    analytics,
  });

  if (!ready) {
    return null;
  }

  // return to default url if not on axis
  if (!usingAxis) {
    console.log('Not on axis - returning null');
    return null;
  }

  return (
    <AxisLayout>
      <AxisContent>
        <Router>
          <Redirect from='/' to={axisPaths.welcome.url} noThrow />
          <AxisWelcomePage path={axisPaths.welcome.slug} />
          <OtherInquiryPage path={axisPaths.otherInquiry.slug} />
          <PromotionalPage path={axisPaths.promotional.slug} />
          <PaymentsPage path={axisPaths.payments.slug} />
          <ClaimsInquiryPage path={axisPaths.claimsInquiry.slug} />
          <CurrentClientPage path={axisPaths.currentClient.slug} />
          <NewClientPage path={axisPaths.newClient.slug} />
          <AxisBasicInformationThankYou path={axisPaths.thanks.slug} />
          <DemoBasicInformationPage path={axisPaths.demoTest.slug} />
        </Router>
        <HelpButton phone={settings.phone} email={settings.email} />
      </AxisContent>
      <AxisFooter />
    </AxisLayout>
  );
};

const AxisLayout = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
});

const AxisContent = styled(Box)({
  flex: 1,
});
